import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import caseReducer from './slices/caseSlice'
import uiReducer from './slices/uiSlice'
import settingsReducer from './slices/settingsSlice'
import userReducer from './slices/userSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    case: caseReducer,
    ui: uiReducer,
    settings: settingsReducer,
    user: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})
